<template>
  <div class="symbol modal-content">
    <div class="box">
      <header class="title is-5">Symbol Selector</header>
      <div class="container symbol__container">
        <b-button
          v-for="symbol in symbols"
          :key="symbol.native"
          class="icon is-medium"
          @click="symbolSelectionHandler(symbol.native)"
        >
          <span
            ><span
              v-if="symbol.previewWithX"
              class="container symbol__container preview"
              >X</span
            >{{ symbol.native }}</span
          >
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import symbols from '../../utils/symbol';

const SymbolSelectorModal = {
  computed: {
    symbols() {
      return symbols;
    }
  },
  methods: {
    async symbolSelectionHandler(symbol) {
      this.$emit('input', symbol);
      this.$emit('close');
    }
  }
};

export default SymbolSelectorModal;
export function getSymbol(parent) {
  return new Promise((resolve, reject) => {
    parent.$buefy.modal.open({
      parent,
      component: SymbolSelectorModal,
      hasModalCard: true,
      events: {
        input: resolve
      },
      onCancel: reject
    });
  });
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.symbol {
  width: auto;

  &__container {
    max-width: 33.6rem;
    .button.is-medium {
      font-size: 1rem;
      margin: 0 0 0.1rem 0.1rem;
    }
    @include tablet {
      min-width: 20rem;
    }
    .preview {
      color: rgb(170, 170, 170);
    }
  }
}
</style>
